import { useEffect, useState } from 'react';
import axios from 'axios';
import ChatComponent from '../../components/websocket/ChatComponent';

const SKELETON_AVATAR_COUNT = 10;

export default function ChatesContainer() {
   const [chates, setChates] = useState([]);
   const [status, setStatus] = useState('loading');
   const [chatId, setChatId] = useState(0);
   const [readedChats, setReadedChats] = useState([]);

   useEffect(() => {
      axios.get('/api/last-chats', { withCredentials: true })
         .then(response => setChates(response.data))
         .catch(err => console.error(err))
         .finally(() => setStatus('done'));
   }, []);

   const closeCallback = () => setChatId(-1);
   const onClickChat = (id) => setChatId(id);
   const readedCallback = (id) => setReadedChats(prev => [...prev, id]);
   const hasUnReaded = (item) => item.hasUnread && !readedChats.some(el => el === item.id);

   const chatOpen = chatId > 0;

   return (
      <div className='main-chates-container'>
         {chatOpen ? (
            <ChatComponent
               key={chatId}
               chatId={chatId}
               closeCallback={closeCallback}
               readedCallback={readedCallback}
            />
         ) : ''}
         <div className='main-chates-wrapper dashboard-component scrooll'>
            {status === 'loading' ? (
               Array.from({ length: SKELETON_AVATAR_COUNT }).map((_, i) => (
                  <div key={i} className='main-chates-element skeleton-block chat-avatar-skeleton'></div>
               ))
            ) : chates.map((item, index) => (
               <div key={item.id}
                  onClick={() => onClickChat(item.id)}
                  className={`main-chates-element chat-avatar-in ${hasUnReaded(item) ? 'unreaded-chat' : 'readed-chat'}`}
                  style={{ '--i': index }}>
                  <div className='chat-name-letter'>{item.name ? item.name[0].toUpperCase() : ''}</div>
                  <div className='chat-name'>{item.name}</div>
                  {hasUnReaded(item) ? <div className='unread'></div> : ''}
               </div>
            ))}
         </div>
      </div>
   );
}
